module.exports = __webpack_public_path__ + "static/media/re.b6a354b9.svg";